import { AuthService } from "@/services";

const PM7_ANALYTICS_KEY = "pk_live_885b9c16a23994888cc920035b842a78dd93052af8a804fbcfef1a19f24e7c34";
const PM7_INGEST_ENDPOINT = "https://analytics.pm7.dev/api/ingest";
const PM7_EVENTS_ENDPOINT = "https://analytics.pm7.dev/api/events";
const PM7_PROJECT_ID = "eb4e3ab9-fa93-422f-8e33-70dfc62421f7";

// analytics.pm7.dev rejects localhost origins with 403; repeated 403s get the
// developer's IP banned by CrowdSec on the server. Never track from local dev.
function isLocalDev(): boolean {
	const h = window.location.hostname;
	return h === "localhost" || h === "127.0.0.1";
}

// Generate or retrieve visitor ID (persisted across sessions)
function getVisitorId(): string {
	const key = "pm7_visitor_id";
	let visitorId = localStorage.getItem(key);
	if (!visitorId) {
		visitorId = crypto.randomUUID();
		localStorage.setItem(key, visitorId);
	}
	return visitorId;
}

// Generate or retrieve session ID (cleared when browser closes)
function getSessionId(): string {
	const key = "pm7_session_id";
	let sessionId = sessionStorage.getItem(key);
	if (!sessionId) {
		sessionId = crypto.randomUUID();
		sessionStorage.setItem(key, sessionId);
	}
	return sessionId;
}

// Track page views
export async function trackPageView(): Promise<void> {
	if (typeof window === "undefined" || isLocalDev()) return;
	try {
		await fetch(PM7_INGEST_ENDPOINT, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-PM7-API-Key": PM7_ANALYTICS_KEY,
			},
			body: JSON.stringify({
				projectId: PM7_PROJECT_ID,
				events: [{
					event_type: "page_view",
					url: window.location.href,
					properties: {
						dossierId: AuthService.wfDossier.id,
						userId: AuthService.wfUser.ID
					},
					referrer: document.referrer || undefined,
					ts: new Date().toISOString(),
					visitor_id: getVisitorId(),
					session_id: getSessionId(),
					user_agent: navigator.userAgent,
					screen_w: window.screen.width,
					screen_h: window.screen.height,
					language: navigator.language,
					consent_provided: false,
				}],
			}),
		});
	} catch {
		// Silently fail - analytics should never break the app
	}
}


// Track custom events (button clicks, purchases, form submissions, etc.)
export async function trackEvent(name: string, properties?: Record<string, string | number | boolean>): Promise<void> {
	if (typeof window === "undefined" || isLocalDev()) return;

	try {
		await fetch(PM7_EVENTS_ENDPOINT, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-PM7-API-Key": PM7_ANALYTICS_KEY,
			},
			body: JSON.stringify({
				projectId: PM7_PROJECT_ID,
				events: [{
					name,
					properties: {
						...properties,
						dossierId: AuthService.wfDossier.id,
						userId: AuthService.wfUser.ID
					},
					ts: new Date().toISOString(),
					visitor_id: getVisitorId(),
					session_id: getSessionId(),
					url: window.location.href,
					consent_provided: false,
				}],
			}),
		});
	} catch {
		// Silently fail - analytics should never break the app
	}
}
